Directives.SearchFileDirective =  function SearchFileDirective(){

    // @ngInject
    function SearchFileDirectiveControllerFunc($scope, $injector, $state, AppStates,
                                               AnalyticsService, WorkspaceFileService, ModelFactory, Enums,
                                               UIUtils, UsersManager){

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SearchFileDirectiveController';

        this.AppStates = AppStates;
        this.goToInProgress = false;
        this.WorkspaceFileService = WorkspaceFileService;
        this.AnalyticsService = AnalyticsService;

        this.workspaceFile = ModelFactory.newWorkspaceFileModel();
        // Build a file model from the search result. might be cool to cache it OR put it in master collection for performance,
        // but first need to make sure what is the bare min for other parts of the system no to fail... not easy.
        this.workspaceFile.mixinFrom(this.searchResult, undefined, false, false);
        this.Enums = Enums;

        this.workspaceFile.statusClass = UIUtils.generateClassByFileType(this.workspaceFile.file_type_cd);
        this.workspaceFile.statusLabel = this.WorkspaceFileService.getStatusLabel(this.workspaceFile, true);
        this.file_type_camelcase = WorkspaceFileService.formatFileTypeToDisplayName(this.workspaceFile.file_type, true);

        this.showEventName = (this.searchResult.file_title || '').toLowerCase().indexOf((this.searchResult.event_name || '').toLowerCase()) === -1;


        this.membersExcludingMe = this.searchResult.members.filter(function (e) {
            return (e.email && (e.email !== UsersManager.getCurrUser().email));
        });

        // window.console.log('workspaceFile', this.workspaceFile);

    }

    var SearchFileDirectiveController = Class(Controllers.BaseController, {
        constructor: SearchFileDirectiveControllerFunc,

        getStatusLabel: function getStatusLabel() {
            return this.WorkspaceFileService.getStatusLabel(this.workspaceFile);
        },
        goFile: function goFile ($event){
            $event.preventDefault();
            this.goToInProgress = true;
            this.WorkspaceFileService.gotoWorkspaceFileById(this.searchResult.workspace_file_id, null, null, false);

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.search_result_item_clicked,
                {searched_id: this.fileId, searched_type: 'File'});
        }

    });

    return {
        scope:{
            searchResult: "=searchResult",
            searchPhrase: '@searchPhrase'
        },
        templateUrl : 'angular/app/modules/core/features/search/file/search_file_directive_template.html',
        controller : SearchFileDirectiveController,
        controllerAs : 'searchFileVm',
        bindToController : true

    };
};
